export default "__VITE_ASSET__CK6H3pOX__"